var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fish-row',{attrs:{"gutter":"1"}},[_c('fish-col',{staticClass:"demo-col",attrs:{"type":"fixed","width":250}},[_vm._v("Fixed-Width")]),_vm._v(" "),_c('fish-col',{staticClass:"demo-col demo-col2",attrs:{"type":"auto"}},[_vm._v("content: auto width ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e21687b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./examples/components/DemoGridFixed.vue
// module id = 782
// module chunks = 1